// components
import Label from './label'

// types
import { BaseFieldProps } from '../field'

export type CheckboxProps = {
	readonly type: 'checkbox' | 'radio'
} & BaseFieldProps &
	React.InputHTMLAttributes<HTMLInputElement>

const Checkbox = (props: CheckboxProps): JSX.Element => {
	const { className, label, ...attr } = props

	return (
		<label>
			<input {...attr} />
			<Label label={label} required={attr.required} />
		</label>
	)
}

export default Checkbox
